import { Component, ElementRef } from '@angular/core';
import 'moment/locale/id';
import * as moment from 'moment';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { BaseListBComponent } from '../../../libraries/base/list/base-list.bcomponent';
import { AgentBfiClaimRestService } from '../agent-bfi-claim-rest.service';
import { ExportDataTableService } from '../../../libraries/export/export-data-table.service';
import { AuthenticationService } from '../../../libraries/auth/authentication.service';
import { AclService } from '../../../libraries/auth/acl.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-agent-bfi-claim-list',
  templateUrl: 'agent-bfi-claim-list.component.html'
})
export class AgentBfiClaimListComponent extends BaseListBComponent<any> {
  tableColumns = [
    {
      i18nLabel: 'ui.agentBfiClaim.entity.no',
      field: 'no'
    },
    {
      i18nLabel: 'ui.agentBfiClaim.entity.affiliator',
      name: 'affiliator',
      field: '',
      sort: true
    },
    {
      i18nLabel: 'ui.agentBfiClaim.entity.buyerName',
      field: 'buyerName',
      sort: true
    },
    {
      i18nLabel: 'ui.agentBfiClaim.entity.status',
      name: 'status',
      field: '',
      sort: true
    },
    {
      i18nLabel: 'ui.agentBfiClaim.entity.orderDate',
      field: 'orderDate',
      sort: true
    },
    {
      i18nLabel: 'ui.agentBfiClaim.entity.motorType',
      field: 'motorType',
      sort: true
    },
    {
      i18nLabel: 'ui.agentBfiClaim.entity.trx',
      name: 'trx',
      field: '',
      sort: true
    },
    {
      i18nLabel: 'ui.agentBfiClaim.entity.picName',
      field: 'picName',
      sort: true
    },
    {
      i18nLabel: 'ui.agentBfiClaim.entity.picPhone',
      field: 'picPhone',
      sort: true
    },
    {
      i18nLabel: 'ui.agentBfiClaim.entity.ktpNumber',
      field: 'ktpNumber',
      sort: true
    },
    {
      i18nLabel: 'ui.agentBfiClaim.entity.createdAt',
      field: 'createdAt',
      sort: true
    },
    {
      i18nLabel: 'ui.agentBfiClaim.entity.updatedAt',
      field: 'updatedAt',
      sort: true
    },
    {
      i18nLabel: 'ui.agentBfiClaim.entity.statusHistory',
      field: '',
      name: 'statusHistory',
      sort: false
    }
  ];
  tableColumnsShow: boolean = false;
  tableColumnsToggle = this._gridTableToggle.mapToggleOptionsFromColumns(this.tableColumns);
  isLoadingExportExcel: boolean = false;
  isDealerModalOpen: boolean = false;
  dealerOpened: any = {};
  isAffiliatorModalOpen: boolean = false;
  affiliatorOpened: any = {};
  isTrxModalOpen: boolean = false;
  trxOpened: any = [];
  isStatusHistoryModalOpen: boolean = false;
  statusHistoryOpened: any = {};

  affiliatorClaimStatuses = [
    {
      text: 'Semua Status',
      value: ''
    },
    {
      text: 'Request',
      value: 'request'
    },
    {
      text: 'Waiting Payment',
      value: 'waiting payment'
    },
    {
      text: 'Processed',
      value: 'processed'
    },
    {
      text: 'Paid',
      value: 'paid'
    },
    {
      text: 'Rejected',
      value: 'rejected'
    }
  ];

  constructor(
    public _authentication: AuthenticationService,
    private _AffiliatorClaimRest: AgentBfiClaimRestService,
    private _export: ExportDataTableService,
    private _AclService: AclService,
    private el: ElementRef
  ) {
    super();
    this.componentId = 'AffiliatorClaimListComponent';
    this.headerTitle = 'ui.agentBfiClaim.list.title';

    this.qParams.status = '';
  }

  appDefineFixedHooks() {
    super.appDefineFixedHooks();

    this.registerHook({
      hookName: 'loadData',
      handle: event => {
        const qOption = event.data.qOption;
        qOption['limit'] = qOption['take'];
        delete qOption['take'];
        delete qOption['skip'];
        const qParams = Object.assign({}, event.data.qParams, qOption, this.qParams);
        return this._AffiliatorClaimRest.findAll(qParams).pipe(
          switchMap(doc => {
            const dataFormatted = doc?.data?.map(d => {
              d.orderDate = moment(d?.orderDate).format('DD MMMM YYYY');
              d.createdAt = moment(d?.createdAt).format('DD MMMM YYYY HH:mm');
              d.updatedAt = moment(d?.updatedAt).format('DD MMMM YYYY HH:mm');
              return d;
            });
            doc.data = dataFormatted;
            return of(doc);
          })
        );
      },
      wrapRetryableTask: true,
      wrapErrorMessage: true
    });

    this.registerHook({
      hookName: 'init',
      handle: () => this.page.compHookService?.callMultipleHooks(['AffiliatorClaimListComponent:workflowLoadData'])
    });
  }

  appOnInit() {
    super.appOnInit();

    return this.callHook('init');
  }

  openDealerModal(data) {
    this.isDealerModalOpen = true;
    this.dealerOpened = data;
  }

  closeDealerModal() {
    this.isDealerModalOpen = false;
  }

  openAffiliatorModal(data) {
    this.isAffiliatorModalOpen = true;
    this.affiliatorOpened = data;
  }

  closeAffiliatorModal() {
    this.isAffiliatorModalOpen = false;
  }

  async openTrxModal(files) {
    this.isTrxModalOpen = true;
    this.trxOpened = files;
    files.forEach((file, index) => {
      const payload = { storageFileName: file?.storageFileName };
      this.renderPresignedUrlImage(payload, `#js-photoPreview-${index}`);
    });
  }

  closeTrxModal() {
    this.isTrxModalOpen = false;
  }

  showStatusHistoryModal(data: any) {
    this.isStatusHistoryModalOpen = true;
    this.statusHistoryOpened = data;
  }

  closeStatusHistoryModal() {
    this.isStatusHistoryModalOpen = false;
  }

  canAccess(pageAction: string) {
    const userAccess: string[] = this._AclService?.exclusivePermissions;
    return userAccess.find(action => action === pageAction);
  }

  async renderPresignedUrlImage(payload: object, elementId: string) {
    await this._AffiliatorClaimRest.getPresignedUrl(payload).subscribe(
      data => {
        const photoPreview = this.el.nativeElement.querySelector(elementId);

        if (photoPreview) {
          photoPreview.src = data.url;
          photoPreview.href = data.url;
        }
      },
      error => {
        const photoPreview = this.el.nativeElement.querySelector(elementId);
        if (photoPreview) {
          photoPreview.src = '';
        }
      }
    );
  }

  toAction(status: string) {
    if (status == 'waiting payment') return 'Waiting Payment';
    if (status == 'processed') return 'Approved';
    if (status == 'rejected') return 'Rejected';
    if (status == 'paid') return 'Paid';
  }

  onApproval(id, affiliatorId, action) {
    Swal.fire({
      title: `Update status to ${this.toAction(action)}?`,
      icon: 'question',
      showCancelButton: true
    }).then(result => {
      if (result.value) {
        this.approveAffiliatorClaim(id, affiliatorId, action);
      } else {
        return;
      }
    });
  }

  async approveAffiliatorClaim(id, affiliatorId, action) {
    await this._AffiliatorClaimRest
      .approval({ _id: id, affiliatorId, status: action })
      .toPromise()
      .then(response => {
        if (response) {
          Swal.fire('Status updated successfully!', '', 'success');
          this.callHookDirectly('init');
        }
      })
      .catch(error => {
        this.comp._globalSystemMessage.log({
          message: 'Error',
          type: 'error',
          scroll: true
        });
      });
  }

  async onDownloadExcel() {
    this.isLoadingExportExcel = true;
    try {
      const result = await this._AffiliatorClaimRest.findAll({}).toPromise();
      const mapOption = {
        affiliatorName: { header: 'Nama Affiliator' },
        memberId: { header: 'Member ID Affiliator' },
        phone: { header: 'No Telepon Affiliator' },
        ktpNumber: { header: 'Nomor KTP Affiliator' },
        email: { header: 'Email Affiliator' },
        address: { header: 'Alamat Affiliator' },
        bankName: { header: 'Nama Bank Affiliator' },
        bankAccount: { header: 'No Rekening Affiliator' },
        status: { header: 'Status' },
        buyerName: { header: 'Nama Pembeli' },
        orderDate: { header: 'Tanggal Pembelian' },
        motorType: { header: 'Jenis Motor' },
        picName: { header: 'Nama PIC' },
        picPhone: { header: 'No Telepon PIC' },
        dealer: { header: 'Dealer' },
        updatedAt: { header: 'Tanggal Diupdate' },
        createdAt: { header: 'Tanggal Submit' }
      };
      const payload = result.data.map(item => ({
        ...item,
        orderDate: moment(item?.orderDate).format('DD MMMM YYYY'),
        affiliatorName: item.affiliator?.name,
        memberId: item.affiliator?.memberId,
        phone: item.affiliator?.phone,
        ktpNumber: item.affiliator?.ktpNumber,
        email: item.affiliator?.email,
        address: item.affiliator?.address,
        bankName: item.affiliator?.bankName,
        bankAccount: item.affiliator?.bankAccount,
        dealer: item.dealer?.name,
        updatedAt: moment(item?.updatedAt).format('DD MMMM YYYY HH:mm'),
        createdAt: moment(item?.createdAt).format('DD MMMM YYYY HH:mm')
      }));
      this._export.export({
        extension: 'xlsx',
        fileName: 'Affiliator Claim',
        records: payload,
        mapOptions: mapOption,
        templateData: null,
        pdfOptions: null
      });
    } catch (error) {
      console.log(error);
    } finally {
      this.isLoadingExportExcel = false;
    }
  }

  getStatusColor(status: string) {
    if (status == 'request') return 'warning';
    if (status == 'draft') return 'secondary';
    if (status == 'waiting payment') return 'primary';
    if (status == 'processed') return 'success';
    if (status == 'paid') return 'success';
    if (status == 'rejected') return 'danger';
  }

  formatDate(date: string) {
    return moment(date).format('DD MMMM YYYY HH:mm');
  }
}
